<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="">
    <div class="form-group row">
      <div class="col-md-12">
        <yt-dropdown-picklist
        [ModelName]="'posao'"
        [GetName]="'get'"
        [ModelProperty]="'Naziv'" 
        [OrderBy]="'Naziv'"
        [AllowAddNew]='true'
        formControlName="PosloviID"
        [Label]="'POSLOVI.NAZIV.SINGULAR'" 
        [Type]="'treeview'">
        </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.PosloviID.invalid">
          <span *ngFor="let validation of errorMessages.PosloviID">
            <span class="error-message" *ngIf="fc.PosloviID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
        </div>
      </div>
    </div>
  </form>
</div>
